// React import
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// Components imports
import SelectBlockchain from "../SelectBlockchain";
import CheckWallet from "../CheckWallet";
import TokenAnalyzer from "../TokenAnalyzer";
import AiCircle from "../AiCircle";
import AiAnalytics from "../AiAnalytics";
import UserArea from "../UserArea";
import Upgrade from "../Upgrade";
// Actions imports
import { setPage } from "../../actions";
// Consts imports
import {
    PAGE_HOME,
    PAGE_CHECK_WALLET,
    PAGE_TOKEN_ANALYZER,
    PAGE_AI_ANALYTICS,
    PAGE_USER_AREA, PAGE_UPGRADE
} from "../../consts/consts";

class Page extends React.Component {

    render () {

        const { page } = this.props.page;

        if(page === PAGE_HOME) {
            return (<AiCircle/>);
        } else if (page === PAGE_CHECK_WALLET) {
            return (<CheckWallet/>);
        } else if (page === PAGE_TOKEN_ANALYZER) {
            return (<TokenAnalyzer/>);
        } else if (page === PAGE_AI_ANALYTICS) {
            return(<AiAnalytics/>);
        } else if (page === PAGE_USER_AREA) {
            return(<UserArea/>);
        } else if (page === PAGE_UPGRADE) {
            return(<Upgrade/>);
        }
        else {
            return(
                <SelectBlockchain/>
            );
        }
    }
}

const mapStateToProps = ({ page }) => {
    return { page };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setPage: setPage
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
